import type { SpecialtyKey } from '~/types/onboarding'
import type { LocalizedText } from '~/types/site'

export type SpecialtyDef = {
  key: SpecialtyKey
  label: LocalizedText
  icon: string
  services: LocalizedText[]
}

export const SPECIALTIES: SpecialtyDef[] = [
  {
    key: 'cardiology',
    label: { fa: 'قلب و عروق', en: 'Cardiology' },
    icon: 'i-lucide-heart-pulse',
    services: [
      { fa: 'اکوکاردیوگرافی', en: 'Echocardiography' },
      { fa: 'نوار قلب', en: 'ECG' },
      { fa: 'مشاوره فشار خون', en: 'Blood pressure consult' },
    ],
  },
  {
    key: 'dermatology',
    label: { fa: 'پوست', en: 'Dermatology' },
    icon: 'i-lucide-sparkles',
    services: [
      { fa: 'درمان آکنه', en: 'Acne treatment' },
      { fa: 'لیزر پوست', en: 'Skin laser' },
      { fa: 'مشاوره زیبایی', en: 'Aesthetic consult' },
    ],
  },
  {
    key: 'dentistry',
    label: { fa: 'دندان', en: 'Dentistry' },
    icon: 'i-lucide-smile',
    services: [
      { fa: 'جرم‌گیری', en: 'Scaling' },
      { fa: 'عصب‌کشی', en: 'Root canal' },
      { fa: 'ایمپلنت', en: 'Implants' },
    ],
  },
  {
    key: 'internal',
    label: { fa: 'داخلی', en: 'Internal medicine' },
    icon: 'i-lucide-stethoscope',
    services: [
      { fa: 'ویزیت عمومی', en: 'General visit' },
      { fa: 'چکاپ دوره‌ای', en: 'Periodic checkup' },
      { fa: 'مشاوره تغذیه', en: 'Nutrition advice' },
    ],
  },
  {
    key: 'pediatrics',
    label: { fa: 'اطفال', en: 'Pediatrics' },
    icon: 'i-lucide-baby',
    services: [
      { fa: 'واکسیناسیون', en: 'Vaccination' },
      { fa: 'رشد و تکامل', en: 'Growth monitoring' },
      { fa: 'بیماری‌های شایع کودکان', en: 'Common childhood illnesses' },
    ],
  },
  {
    key: 'orthopedics',
    label: { fa: 'ارتوپدی', en: 'Orthopedics' },
    icon: 'i-lucide-bone',
    services: [
      { fa: 'درمان آسیب ورزشی', en: 'Sports injury care' },
      { fa: 'درد مفاصل', en: 'Joint pain' },
      { fa: 'فیزیوتراپی', en: 'Physiotherapy' },
    ],
  },
  {
    key: 'gynecology',
    label: { fa: 'زنان', en: 'Gynecology' },
    icon: 'i-lucide-flower-2',
    services: [
      { fa: 'ویزیت زنان', en: 'Gynecology visit' },
      { fa: 'مراقبت بارداری', en: 'Prenatal care' },
      { fa: 'سونوگرافی', en: 'Ultrasound' },
    ],
  },
  {
    key: 'psychiatry',
    label: { fa: 'روانپزشکی', en: 'Psychiatry' },
    icon: 'i-lucide-brain',
    services: [
      { fa: 'مشاوره اضطراب', en: 'Anxiety counseling' },
      { fa: 'درمان افسردگی', en: 'Depression treatment' },
      { fa: 'جلسه روان‌درمانی', en: 'Psychotherapy session' },
    ],
  },
  {
    key: 'nutrition',
    label: { fa: 'تغذیه', en: 'Nutrition' },
    icon: 'i-lucide-apple',
    services: [
      { fa: 'رژیم کاهش وزن', en: 'Weight-loss plan' },
      { fa: 'تغذیه ورزشی', en: 'Sports nutrition' },
      { fa: 'مشاوره دیابت', en: 'Diabetes nutrition' },
    ],
  },
  {
    key: 'other',
    label: { fa: 'سایر', en: 'Other' },
    icon: 'i-lucide-plus-circle',
    services: [
      { fa: 'مشاوره تخصصی', en: 'Specialist consult' },
      { fa: 'ویزیت حضوری', en: 'In-person visit' },
      { fa: 'پیگیری درمان', en: 'Follow-up care' },
    ],
  },
]

export function getSpecialty(key: SpecialtyKey): SpecialtyDef {
  return SPECIALTIES.find((s) => s.key === key) ?? SPECIALTIES[SPECIALTIES.length - 1]!
}
